import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import useAddonSubmit from "hooks/useAddonSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";
import SelectVia from "components/form/SelectVia";
import TextAreaCom from "components/form/TextAreaCom";
import DrawerButton from "components/form/DrawerButton";
import SelectCityMultiple from "components/form/SelectCityMultiple";
// import InputAreaPrice from "components/form/InputAreaPrice";
import SelectAirportMultiple from "components/form/SelectAirportMultiple";
const AddonDrawer = ({ id }) => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    loading,
    errors,
    selectedCity,
    setSelectedCity,
    serviceType,
    setServiceType,
  } = useAddonSubmit(id);

  const [status, setStatus] = useState(false);

  const handleCheck = async (value) => {
    setServiceType(value);
  };
  useEffect(() => {
    setStatus(serviceType === "Airport");
  }, [serviceType]);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Addon Type" />
        ) : (
          <Title register={register} title="Add Addon Type" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  {id ? (
                    <>
                      <div className="col-span-6">
                        <LabelArea label={"Type of Service"} />
                      </div>
                      <div className="col-span-6">
                        <p>{serviceType}</p>
                      </div>
                    </>
                  ) : (
                    <div className="col-span-6">
                      <LabelArea label={"Type of Service"} required />
                      <SelectVia
                        title={"Service"}
                        register={register}
                        required={true}
                        defaultValue={serviceType}
                        onChange={(e) => handleCheck(e.target.value)}
                        name="service_type"
                        label="Type of Service"
                      />
                      <Error errorName={errors.service_type} />
                    </div>
                  )}

                  <div className="col-span-6">
                    {status ? (
                      <>
                        <LabelArea required label={"Airport"} />
                        <SelectAirportMultiple
                          onSelectState={setSelectedCity}
                          register={register}
                          required={false}
                          name="city"
                          selectedServiceState={selectedCity}
                          setSelectedServiceState={setSelectedCity}
                        />
                      </>
                    ) : (
                      <>
                        <LabelArea required label={"City"} />
                        <SelectCityMultiple
                          onSelectState={setSelectedCity}
                          register={register}
                          required={false}
                          name="city"
                          selectedServiceState={selectedCity}
                          setSelectedServiceState={setSelectedCity}
                        />
                      </>
                    )}

                    <Error errorName={errors.city} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Addon Type" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Addon Type"
                      name="name"
                      type="text"
                      placeholder="Addon Type"
                    />
                    <Error errorName={errors.name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Price" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Price"
                      name="price"
                      type="number"
                      maxLength={6}
                      placeholder="Enter price"
                    />
                    <Error errorName={errors.price} />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea label="Tax" required />
                    <InputAreaPrice
                      trigger={trigger}
                      register={register}
                      label="Tax"
                      name="tax"
                      maxLength={2}
                      placeholder="Enter Tax"
                    />
                    <Error errorName={errors.tax} />
                  </div> */}

                  <div className="col-span-12">
                    <LabelArea label="Description" required />
                    <TextAreaCom
                      trigger={trigger}
                      register={register}
                      label="Description"
                      name="description"
                      type="text"
                      placeholder="Enter description"
                    />
                    <Error errorName={errors.description} />
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default AddonDrawer;
